<template>
  <v-text-field
    :label="$t('forms.EMAIL')"
    v-model="email"
    v-on:input="updateValue"
    type="email"
    :rules="emailRules"
    required
    validate-on-blur
    :autofocus="autofocus"
  ></v-text-field>
</template>

<script>
  export default {
    name: 'evaloe-email-field',
    props: ['value', 'autofocus'],
    data () {
      return {
        emailRules: [
          (v) => !!v || 'E-mail is required',
          (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w+)+$/.test(v) || 'E-mail must be valid'
        ],
        email: ''
      }
    },
    watch: {
      value (val) {
        this.email = val
      }
    },
    created () {
      if (this.value) {
        this.email = this.value
      }
    },
    methods: {
      updateValue: function (value) {
        this.$emit('input', value)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/evaloeEmailField.vue